import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LoginService } from '../services/login.service';
import { CasherService } from '../services/casher.service';

@Injectable({
  providedIn: 'root'
})
export class OrdersGuard implements CanActivate, CanActivateChild {

  constructor(private router: Router, private loginService:LoginService,private casherService:CasherService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const token = localStorage.getItem('ACCESS_TOKEN');
      let isSupervisor = null;
      if(this.casherService.getSupervisor != null){
        isSupervisor = this.casherService.getSupervisor;
      }else{
        isSupervisor = localStorage.getItem('SUPERVISOR') === 'true';
      }
      if(token != null){
        this.loginService.refresh();
      }
      if (!this.loginService.isAuthenticateds()) {
        this.router.navigate(['/user-pages/login']);
        return false;
      }else if(!this.loginService.hasAnyRole(['ADMIN', 'SELLER', 'SELLER-ADMIN', 'CASHIER','CASHIER-SELLER'])){
        this.router.navigate(['/dashboard']);
        return false;
      }else return true;
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const token = localStorage.getItem('ACCESS_TOKEN');
      let isSupervisor = null;
      if(this.casherService.getSupervisor != null){
        isSupervisor = this.casherService.getSupervisor;
      }else{
        isSupervisor = localStorage.getItem('SUPERVISOR') === 'true';
      }
      
      if(token != null){
        this.loginService.refresh();
      }
      if (!this.loginService.isAuthenticateds()) {
        this.router.navigate(['/user-pages/login']);
        return false;
      }else if(!this.loginService.hasAnyRole(['ADMIN', 'SELLER', 'SELLER-ADMIN','CASHIER','CASHIER-SELLER'])){
        this.router.navigate(['/dashboard']);
        return false;
      }else if(state.url == "/orders/add-order" && this.loginService.hasAnyRole(['CASHIER'])){
        this.router.navigate(['/orders/orders-carousel']);
        return false;
      }else if(state.url == "/orders/add-order-sumary" && this.loginService.hasAnyRole(['CASHIER'])){
        this.router.navigate(['/orders/orders-carousel']);
        return false;
      }else if(state.url == "/orders/all-orders-report" && (!this.loginService.hasAnyRole(['ADMIN']) && !isSupervisor)){
        this.router.navigate(['/dashboard']);
        return false;
      }else return true;
  }

}
